import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class GameUIResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("GameUIResourcesPackage");
    }
    public get assets_game_ad_play_btn_png(): Texture {
        return this.resource<Texture>("assets/game/ad_play_btn.png");
    }
    public get assets_game_arrows_png(): Texture {
        return this.resource<Texture>("assets/game/arrows.png");
    }
    public get assets_game_background_png(): Texture {
        return this.resource<Texture>("assets/game/background.png");
    }
    public get assets_game_background_game_png(): Texture {
        return this.resource<Texture>("assets/game/background_game.png");
    }
    public get assets_game_background_game_mobile_png(): Texture {
        return this.resource<Texture>("assets/game/background_game_mobile.png");
    }
    public get assets_game_blue_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/blue_bottom_left.png");
    }
    public get assets_game_blue_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/blue_bottom_right.png");
    }
    public get assets_game_blue_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/blue_top_left.png");
    }
    public get assets_game_blue_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/blue_top_right.png");
    }
    public get assets_game_button_icon_erase_png(): Texture {
        return this.resource<Texture>("assets/game/button/icon/erase.png");
    }
    public get assets_game_button_icon_info_png(): Texture {
        return this.resource<Texture>("assets/game/button/icon/info.png");
    }
    public get assets_game_button_icon_remove_triangles_png(): Texture {
        return this.resource<Texture>("assets/game/button/icon/remove_triangles.png");
    }
    public get assets_game_button_icon_settings_png(): Texture {
        return this.resource<Texture>("assets/game/button/icon/settings.png");
    }
    public get assets_game_button_icon_shuffle_png(): Texture {
        return this.resource<Texture>("assets/game/button/icon/shuffle.png");
    }
    public get assets_game_button_substrate_purpure_png(): Texture {
        return this.resource<Texture>("assets/game/button/substrate/purpure.png");
    }
    public get assets_game_cell_png(): Texture {
        return this.resource<Texture>("assets/game/cell.png");
    }
    public get assets_game_counter_substrate_png(): Texture {
        return this.resource<Texture>("assets/game/counter_substrate.png");
    }
    public get assets_game_deck_substrate_png(): Texture {
        return this.resource<Texture>("assets/game/deck/substrate.png");
    }
    public get assets_game_effects_booster_promotion_booster_promotion_atlas(): any {
        return this.resource<any>("assets/game/effects/booster_promotion/booster_promotion.atlas");
    }
    public get assets_game_effects_booster_promotion_booster_promotion_json(): Object {
        return this.resource<Object>("assets/game/effects/booster_promotion/booster_promotion.json");
    }
    public get assets_game_effects_booster_promotion_booster_promotion_png(): Texture {
        return this.resource<Texture>("assets/game/effects/booster_promotion/booster_promotion.png");
    }
    public get assets_game_effects_combo_grace_atlas(): any {
        return this.resource<any>("assets/game/effects/combo/grace.atlas");
    }
    public get assets_game_effects_combo_grace_json(): Object {
        return this.resource<Object>("assets/game/effects/combo/grace.json");
    }
    public get assets_game_effects_combo_grace_png(): Texture {
        return this.resource<Texture>("assets/game/effects/combo/grace.png");
    }
    public get assets_game_effects_game_over_Great_animation_atlas(): any {
        return this.resource<any>("assets/game/effects/game_over/Great_animation.atlas");
    }
    public get assets_game_effects_game_over_Great_animation_json(): Object {
        return this.resource<Object>("assets/game/effects/game_over/Great_animation.json");
    }
    public get assets_game_effects_game_over_Great_animation_png(): Texture {
        return this.resource<Texture>("assets/game/effects/game_over/Great_animation.png");
    }
    public get assets_game_effects_initialize_field_initialize_field_atlas(): any {
        return this.resource<any>("assets/game/effects/initialize_field/initialize_field.atlas");
    }
    public get assets_game_effects_initialize_field_initialize_field_json(): Object {
        return this.resource<Object>("assets/game/effects/initialize_field/initialize_field.json");
    }
    public get assets_game_effects_initialize_field_initialize_field_png(): Texture {
        return this.resource<Texture>("assets/game/effects/initialize_field/initialize_field.png");
    }
    public get assets_game_effects_triangles_appearance_destroy_atlas(): any {
        return this.resource<any>("assets/game/effects/triangles/appearance_destroy.atlas");
    }
    public get assets_game_effects_triangles_appearance_destroy_json(): Object {
        return this.resource<Object>("assets/game/effects/triangles/appearance_destroy.json");
    }
    public get assets_game_effects_triangles_appearance_destroy_png(): Texture {
        return this.resource<Texture>("assets/game/effects/triangles/appearance_destroy.png");
    }
    public get assets_game_gamefield_png(): Texture {
        return this.resource<Texture>("assets/game/gamefield.png");
    }
    public get assets_game_green_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/green_bottom_left.png");
    }
    public get assets_game_green_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/green_bottom_right.png");
    }
    public get assets_game_green_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/green_top_left.png");
    }
    public get assets_game_green_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/green_top_right.png");
    }
    public get assets_game_infoUI_png(): Texture {
        return this.resource<Texture>("assets/game/infoUI.png");
    }
    public get assets_game_orange_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/orange_bottom_left.png");
    }
    public get assets_game_orange_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/orange_bottom_right.png");
    }
    public get assets_game_orange_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/orange_top_left.png");
    }
    public get assets_game_orange_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/orange_top_right.png");
    }
    public get assets_game_play_ad_png(): Texture {
        return this.resource<Texture>("assets/game/play_ad.png");
    }
    public get assets_game_purple_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/purple_bottom_left.png");
    }
    public get assets_game_purple_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/purple_bottom_right.png");
    }
    public get assets_game_purple_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/purple_top_left.png");
    }
    public get assets_game_purple_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/purple_top_right.png");
    }
    public get assets_game_red_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/red_bottom_left.png");
    }
    public get assets_game_red_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/red_bottom_right.png");
    }
    public get assets_game_red_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/red_top_left.png");
    }
    public get assets_game_red_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/red_top_right.png");
    }
    public get assets_game_settingsUI_png(): Texture {
        return this.resource<Texture>("assets/game/settingsUI.png");
    }
    public get assets_game_shuffle_btn_bg_png(): Texture {
        return this.resource<Texture>("assets/game/shuffle_btn_bg.png");
    }
    public get assets_game_special_slot_bg_png(): Texture {
        return this.resource<Texture>("assets/game/special_slot_bg.png");
    }
    public get assets_game_yellow_bottom_left_png(): Texture {
        return this.resource<Texture>("assets/game/yellow_bottom_left.png");
    }
    public get assets_game_yellow_bottom_right_png(): Texture {
        return this.resource<Texture>("assets/game/yellow_bottom_right.png");
    }
    public get assets_game_yellow_top_left_png(): Texture {
        return this.resource<Texture>("assets/game/yellow_top_left.png");
    }
    public get assets_game_yellow_top_right_png(): Texture {
        return this.resource<Texture>("assets/game/yellow_top_right.png");
    }
}

